import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';

import variables from '../variables';

const TemplateFormStyles = styled.div`
    font-size: 14px;
    form{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        text-align: left;
        .field-row {
            width: 100%;
        }
        .field-column {
            width: 50%;
        }
        .field-row, .field-column {
            margin-bottom: 8px;
            padding: 5px 0;
        }
        .field-group .field-column:nth-child(odd) {
            padding-right: 5px;
        }
        .field-group .field-column:nth-child(even) {
            padding-left: 5px;
        }
        button {
            height: 55px;
            margin-top: 24px;
            padding-top: 5px;
        }
    }
    .field-group {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
    }
    label {
        font-size: 16px;
        margin-bottom: 5px;
    }
    .template-checkbox-container {
        margin-bottom: 18px;
        & > div {
            padding-top: 16px;
        }
    }
    .template-checkbox[type=checkbox] + label:before {
        top: 5px;
    }
    .template-checkbox + label {
        font-size: 20px;
        
    }
    .form-error{
        color: ${colors.secondaryLadyBug};
        font-size: 12px;
        height: 42px;
        line-height: 1.56;
        letter-spacing: -0.3px;
        margin: 0;
        text-align: left;
    }

    @media screen and (min-width: ${variables.desktop_breakpoint_width}px) {
        width: 390px;
    }
`;

export default TemplateFormStyles;